var render = function () {
  var _vm$rental$document;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.rental.title) + " "), _c('v-spacer'), _vm.canUpdateRental ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.returnDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.return")) + " ")]) : _vm._e(), _vm.canDeleteRental ? _c('m-icon-button', {
    staticClass: "mr-2",
    attrs: {
      "icon": "mdi-trash-can",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.deleteDialog = true;
      }
    }
  }) : _vm._e(), _vm.canUpdateRental ? _c('m-icon-button', {
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.editDialog = true;
      }
    }
  }) : _vm._e(), !_vm.hideGoToDetail ? _c('m-icon-button', {
    staticClass: "ml-2",
    attrs: {
      "icon": "mdi-open-in-new",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click() {
        return _vm.goToDetail();
      }
    }
  }) : _vm._e()], 1), _c('v-row', {
    staticClass: "mb-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.rental.seller ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-text', [_c('invoice-party-sheet', {
    attrs: {
      "invoice-party": _vm.rental.seller,
      "hideDetails": _vm.hideCompanyDetails,
      "color": "white"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.canUpdateRental ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-text', [_c('select-assignees', {
    attrs: {
      "css": "width: 100%",
      "partnerId": _vm.rental.partnerId,
      "outlined": false,
      "dense": false,
      "solo": false
    },
    on: {
      "input": _vm.onAssigneesUpdate,
      "added": _vm.onAssigneesAdded,
      "removed": _vm.onAssigneesRemoved
    },
    model: {
      value: _vm.rental.assignees,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "assignees", $$v);
      },
      expression: "rental.assignees"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), !_vm.isMobile ? _c('v-divider') : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('debug', {
    attrs: {
      "debug": _vm.rental
    }
  }), _c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.rental")) + " ")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": _vm.$t('common.nouns.status'),
      "chips": "",
      "readonly": "",
      "small-chips": "",
      "append-icon": '',
      "hide-details": ""
    },
    model: {
      value: _vm.rental.status,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "status", $$v);
      },
      expression: "rental.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.title'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.title,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "title", $$v);
      },
      expression: "rental.title"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "type": "datetime-local",
      "label": _vm.$t('objects.rental.period.start'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.start,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "start", $$v);
      },
      expression: "rental.start"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "type": "datetime-local",
      "label": _vm.$t('objects.rental.period.end'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.end,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "end", $$v);
      },
      expression: "rental.end"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.periodInDays'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.periodInDays,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "periodInDays", $$v);
      },
      expression: "rental.periodInDays"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.rental.returnDate ? _c('m-text-field', {
    attrs: {
      "hide-details": "",
      "type": "datetime-local",
      "label": _vm.$t('objects.rental.returnDate'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.returnDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "returnDateFormable", $$v);
      },
      expression: "rental.returnDateFormable"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), !_vm.isMobile ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("components.PartnerReportDetail.rental.options")))]), _c('v-card-text', [!_vm.rental.isDelivery && !_vm.rental.isPickup ? _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('m-no-content', {
    attrs: {
      "icon": "mdi-truck-delivery-outline",
      "text": _vm.$t('objects.rental.noPickupAndDelivery'),
      "color": "transparent"
    }
  })], 1) : _vm._e(), _c('v-row', [_vm.rental.isDelivery ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-map-marker-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("objects.rental.isDelivery")) + " "), _c('v-spacer'), _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("detailedDate")(_vm.rental.deliveryDate)) + " ")])], 1), _vm.rental.deliveryLocation ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.rental.deliveryLocation.street) + ", "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.deliveryLocation.zip) + " " + _vm._s(_vm.rental.deliveryLocation.city) + " ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm.rental.isPickup ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-map-marker-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("objects.rental.isPickup")) + " "), _c('v-spacer'), _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("detailedDate")(_vm.rental.pickupDate)) + " ")])], 1), _vm.rental.pickupLocation ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.rental.pickupLocation.street) + ", "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.pickupLocation.zip) + " " + _vm._s(_vm.rental.pickupLocation.city) + " ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), !_vm.isMobile ? _c('v-divider') : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.showCost ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("components.PartnerReportDetail.rental.vehicle")))]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('common.nouns.licenseplate'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "numberplate", $$v);
      },
      expression: "rental.numberplate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.vehicleModel'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.vehicleModel,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "vehicleModel", $$v);
      },
      expression: "rental.vehicleModel"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.vehicleGroup'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.vehicleGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "vehicleGroup", $$v);
      },
      expression: "rental.vehicleGroup"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.rate'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.rate,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "rate", $$v);
      },
      expression: "rental.rate"
    }
  })], 1)], 1)], 1)], 1)], 1), !_vm.isMobile && _vm.showCost ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm.showCost ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("components.PartnerReportDetail.rental.cost")))]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.totalCost'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.totalCostReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "totalCostReadable", $$v);
      },
      expression: "rental.totalCostReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.dailyRate'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.dailyRateReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "dailyRateReadable", $$v);
      },
      expression: "rental.dailyRateReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.costCoveredByCustomer'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.costCoveredByCustomerReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "costCoveredByCustomerReadable", $$v);
      },
      expression: "rental.costCoveredByCustomerReadable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('objects.rental.costCoveredByInsurance'),
      "readonly": ""
    },
    model: {
      value: _vm.rental.costCoveredByInsuranceReadable,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "costCoveredByInsuranceReadable", $$v);
      },
      expression: "rental.costCoveredByInsuranceReadable"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), !_vm.isMobile ? _c('v-divider') : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.showAttachment ? 6 : 12
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('components.fleet.FleetVehicleDetailVehicleCard.notes'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.rental.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.rental, "notes", $$v);
      },
      expression: "rental.notes"
    }
  })], 1)], 1)], 1), !_vm.isMobile && _vm.showAttachment ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm.showAttachment ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('m-expansion', {
    staticClass: "mx-2",
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.document", {
          count: _vm.rental.documentId ? 1 : 0
        })) + " ")];
      },
      proxy: true
    }], null, false, 152230992),
    model: {
      value: _vm.showDocument,
      callback: function callback($$v) {
        _vm.showDocument = $$v;
      },
      expression: "showDocument"
    }
  }, [_vm.rental && _vm.rental.isDocumentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : (_vm$rental$document = _vm.rental.document) !== null && _vm$rental$document !== void 0 && _vm$rental$document.url ? _c('iframe', {
    attrs: {
      "src": _vm.rental.document.url,
      "width": "100%",
      "height": "800px"
    }
  }) : _c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.rental.missing'),
      "color": "transparent"
    }
  })], 1)], 1) : _vm._e()], 1), _c('rental-update-dialog', {
    attrs: {
      "rental": _vm.rental
    },
    model: {
      value: _vm.editDialog,
      callback: function callback($$v) {
        _vm.editDialog = $$v;
      },
      expression: "editDialog"
    }
  }), _c('rental-return-dialog', {
    attrs: {
      "rental": _vm.rental
    },
    model: {
      value: _vm.returnDialog,
      callback: function callback($$v) {
        _vm.returnDialog = $$v;
      },
      expression: "returnDialog"
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.deleteDialog,
      "max-width": "800",
      "title": _vm.$t('components.dialog.DeleteDialog.title'),
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "rightLoading": _vm.rental.loading,
      "rightColor": 'error'
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.deleteDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.deleteDialog = $event;
      },
      "rightClick": _vm.startDeletion,
      "leftClick": function leftClick($event) {
        _vm.deleteDialog = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }